module.exports = __webpack_public_path__ + "static/media/icon-star.66fd2f42.svg";